import * as z from "zod";

export const ShopperAgentEscalationConfigSchema = z.object({
  escalateToSupport: z.boolean(),
  contactEmail: z.string().nullable().optional(),
});

export type ShopperAgentEscalationConfig = z.infer<
  typeof ShopperAgentEscalationConfigSchema
>;

/** Writes only: backfilled rows may predate this rule, so reads use the plain schema. */
export const ShopperAgentEscalationConfigInputSchema =
  ShopperAgentEscalationConfigSchema.refine(
    (config) =>
      config.escalateToSupport || hasContactEmail(config.contactEmail),
    {
      error: "Add a support email before turning off escalation.",
      path: ["contactEmail"],
    },
  );

export function hasContactEmail(
  contactEmail: string | null | undefined,
): boolean {
  return (contactEmail?.trim() ?? "") !== "";
}

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidContactEmail(
  contactEmail: string | null | undefined,
): boolean {
  const trimmed = contactEmail?.trim() ?? "";
  return trimmed === "" || EMAIL_PATTERN.test(trimmed);
}

export interface ResolvedShopperAgentEscalation {
  escalateToSupport: boolean;
  contactEmail: string | null;
}

export const DEFAULT_SHOPPER_AGENT_ESCALATION: ResolvedShopperAgentEscalation =
  { escalateToSupport: true, contactEmail: null };

export interface SupportContactEmailSource {
  customer_email?: string | null;
  settings?: {
    marketing?: {
      supportConnection?: { preferredEmail?: string | null } | null;
    } | null;
    support?: { defaultEmail?: string | null } | null;
  } | null;
}

export function resolveSupportContactEmail(
  team: SupportContactEmailSource,
  contactEmail: string | null | undefined,
): string | null {
  const candidate =
    contactEmail?.trim() ||
    team.settings?.marketing?.supportConnection?.preferredEmail?.trim() ||
    team.settings?.support?.defaultEmail?.trim() ||
    team.customer_email?.trim() ||
    "";
  return candidate === "" ? null : candidate;
}
